import { FC } from "react";
import { AlertCircle } from "lucide-react";

import {
  RmAlert,
  RmAlertDescription,
  RmAlertTitle,
} from "@/components/RmAlert/RmAlert";
import { RmButton } from "@/components/RmButton/RmButton";
import { envVariables } from "@/utils/envVariables";

// eslint-disable-next-line @typescript-eslint/naming-convention
const SHOULD_PRINT_ERROR =
  envVariables.VITE_ENVIRONMENT === "local" ||
  envVariables.VITE_ENVIRONMENT === "preview" ||
  envVariables.VITE_ENVIRONMENT === "development";

type ErrorFallbackPropsType = {
  error: unknown;
  resetError: () => void;
};

export const ErrorFallback: FC<ErrorFallbackPropsType> = ({
  error,
  resetError,
}) => {
  const errorMessage = error instanceof Error ? error.message : undefined;

  return (
    <div className="m-auto flex w-md">
      <RmAlert variant="destructive">
        <AlertCircle className="h-4 w-4" />
        <RmAlertTitle i18nKey="main:errorFallback.title" />
        <RmAlertDescription i18nKey="main:errorFallback.description" />
        <div className="col-start-2 grid justify-items-start gap-4 pt-2">
          {SHOULD_PRINT_ERROR && errorMessage && (
            <div className="w-full rounded-sm bg-primary px-3 py-2 text-primary-foreground">
              <pre className="text-wrap">{errorMessage}</pre>
            </div>
          )}
          <RmButton
            variant="outline"
            i18nKey="main:errorFallback.resetCta"
            className="w-full text-foreground shadow-none"
            onClick={resetError}
          />
        </div>
      </RmAlert>
    </div>
  );
};
